import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { ThreeDots } from 'react-loader-spinner';

import CommonButton from '../../../../components/common-button/CommonButton';
import CommonSwitch from '../../../../components/common-switch/CommonSwitch';

import scss from './LabelSettingsModal.module.scss';

function LabelSettingsFormInner({ onSubmit, onCancel }) {
  const { t } = useTranslation('sonar');
  const { submitting, dirty } = useFormState();

  return (
    <form className={scss.form} onSubmit={onSubmit}>
      <h3 className={scss.title}>{t('labelSettings')}</h3>

      <div className={scss.content}>
        <Field name='groupNames' type='checkbox'>
          {({ input }) => (
            <label htmlFor='groupName' className={scss.switchLabel}>
              <CommonSwitch checked={input.checked} onChange={input.onChange} />
              <span>{t('groupNames')}</span>
            </label>
          )}
        </Field>

        <Field name='countryCode' type='checkbox'>
          {({ input }) => (
            <label htmlFor='groupName' className={scss.switchLabel}>
              <CommonSwitch checked={input.checked} onChange={input.onChange} />
              <span>{t('countryCode')}</span>
            </label>
          )}
        </Field>
      </div>

      <div className={scss.actions}>
        <CommonButton type='reset' styleColor='secondary' maxWidth={120} onClick={onCancel} disabled={submitting}>
          {t('cancel')}
        </CommonButton>

        <CommonButton type='submit' onClick={onSubmit} maxWidth={120} disabled={submitting || !dirty}>
          {submitting ? <ThreeDots height={15} width={40} /> : null}
          {t('apply')}
        </CommonButton>
      </div>
    </form>
  );
}

export default LabelSettingsFormInner;
